import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import product from './modules/product'
import dashboard from './modules/dashboard'
import purchase from './modules/purchase'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    product,
    dashboard,
    purchase
  },
  // 全局状态
  state: {
    loading: false
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    }
  },
  getters: {
    // 添加全局 getters，映射 user 模块的 token
    token: state => state.user.token
  }
}) 